import React, { useContext } from "react";
export var ThemeContext = /*#__PURE__*/React.createContext();

function useTheme() {
  var theme = useContext(ThemeContext);
  return theme;
}

export default useTheme;